import { Role, Seccion } from './enums';

/**
 * Interface para el usuario autenticado
 */
export interface User {
  id: number;
  username: string;
  email: string;
  role: Role;
  nombre: string;
  seccion?: Seccion;
  apellidos: string;
  passwordChangeRequired?: boolean;
  createdAt: string;
  updatedAt: string;
}

/**
 * Interface para las credenciales de login
 */
export interface LoginCredentials {
  email: string;
  password: string;
}

/**
 * Interface para la respuesta del login
 */
export interface LoginResponse {
  token: string;
  user: User;
  expiresIn: number;
}

/**
 * Interface para el contexto de autenticación
 */
export interface AuthContextType {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (credentials: LoginCredentials) => Promise<void>;
  logout: () => void;
  hasRole: (role: Role) => boolean;
  hasAnyRole: (roles: Role[]) => boolean;
}

/**
 * Interface para la solicitud de cambio de contraseña
 */
export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

/**
 * Interface para solicitar reset de contraseña
 */
export interface ForgotPasswordRequest {
  email: string;
}

/**
 * Interface para la respuesta de solicitud de reset
 */
export interface ForgotPasswordResponse {
  message: string;
  success: boolean;
}

/**
 * Interface para verificar el código de reset
 */
export interface VerifyResetCodeRequest {
  email: string;
  code: string;
}

/**
 * Interface para la respuesta de verificación de código
 */
export interface VerifyResetCodeResponse {
  message: string;
  success: boolean;
  resetToken?: string;
}

/**
 * Interface para resetear la contraseña
 */
export interface ResetPasswordRequest {
  resetToken: string;
  newPassword: string;
  confirmPassword: string;
}

/**
 * Interface para la respuesta de reset de contraseña
 */
export interface ResetPasswordResponse {
  message: string;
  success: boolean;
}

/**
 * Enum para los pasos del modal de reset de contraseña
 */
export enum PasswordResetStep {
  EMAIL = 'email',
  CODE = 'code',
  PASSWORD = 'password'
}

/**
 * Interface para el estado del reset de contraseña
 */
export interface PasswordResetState {
  step: PasswordResetStep;
  email: string;
  code: string;
  resetToken: string;
  isLoading: boolean;
  error: string | null;
}

/**
 * Permisos por rol para la aplicación móvil
 */
export const ROLE_PERMISSIONS = {
  [Role.ADMIN]: {
    canAccessAdmin: true,
    canManageProfile: true,
    canViewStats: true,
    canManageTeam: true
  },
  [Role.RESPONSABLE_CAPTACION]: {
    canAccessAdmin: false,
    canManageProfile: true,
    canViewStats: true,
    canManageTeam: true
  },
  [Role.ENTRENADOR]: {
    canAccessAdmin: false,
    canManageProfile: true,
    canViewStats: true,
    canManageTeam: true
  }
} as const;